import React from "react"
import { FlatMapSource, INTERACTABLE_MAP_FLAT_LAYER_IDS } from "./flat_source"
// import { ExtrudedMapSource, INTERACTABLE_MAP_EXTRUDED_LAYER_IDS } from "./extruded_source"

/**
 * Main map source component that delegates to 2D and 3D handlers
 */
export function MapSource({ map, isMapLoading }) {
  return (
    <>
      <FlatMapSource map={map} isMapLoading={isMapLoading} />
      {/*<ExtrudedMapSource map={map} isMapLoading={isMapLoading} />*/}
    </>
  )
}

// Function to get all interactable layer IDs
export function getInteractableLayerIds() {
  return [...INTERACTABLE_MAP_FLAT_LAYER_IDS]
  // return [...INTERACTABLE_MAP_FLAT_LAYER_IDS, ...INTERACTABLE_MAP_EXTRUDED_LAYER_IDS]
}
